export default __webpack_public_path__ + "static/media/Poisonivy.ed2d7c7d.png";